import gql from 'graphql-tag'

import { GravityPictureFragment } from '@thg-commerce/enterprise-network/src/graphql/Fragment/Picture.graphql'

export const WidgetPictures = gql`
  ${GravityPictureFragment}
  fragment WidgetPictures on Widget {
    ... on ResponsiveSliderSet {
      banners {
        ... on GlobalPrimaryBanner {
          picture {
            ...GravityPictureFragment
          }
        }
      }
    }

    ... on GlobalSixItemCategories {
      pictures {
        pictureOne {
          ...GravityPictureFragment
        }
        pictureTwo {
          ...GravityPictureFragment
        }
        pictureThree {
          ...GravityPictureFragment
        }
        pictureFour {
          ...GravityPictureFragment
        }
        pictureFive {
          ...GravityPictureFragment
        }
        pictureSix {
          ...GravityPictureFragment
        }
      }
    }

    ... on GlobalPrimaryBanner {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalTwoItemEditorial {
      pictures {
        pictureOne {
          ...GravityPictureFragment
        }
        pictureTwo {
          ...GravityPictureFragment
        }
      }
    }

    ... on GlobalGeneralImageBanner {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalPrimaryBannerWithList {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalPrimaryBannerWithTextOverlay {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalWidgetVega {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalThreeItemEditorial {
      pictures {
        pictureOne {
          ...GravityPictureFragment
        }
        pictureTwo {
          ...GravityPictureFragment
        }
        pictureThree {
          ...GravityPictureFragment
        }
      }
    }

    ... on GlobalThreeItemEditorialSubtitleBG {
      pictures {
        pictureOne {
          ...GravityPictureFragment
        }
        pictureTwo {
          ...GravityPictureFragment
        }
        pictureThree {
          ...GravityPictureFragment
        }
      }
    }

    ... on GlobalEditorialWithFeature {
      pictures {
        pictureOne {
          ...GravityPictureFragment
        }
        pictureTwo {
          ...GravityPictureFragment
        }
        featuredPicture {
          ...GravityPictureFragment
        }
      }
    }

    ... on GlobalFourItemEditorial {
      pictures {
        pictureOne {
          ...GravityPictureFragment
        }
        pictureTwo {
          ...GravityPictureFragment
        }
        pictureThree {
          ...GravityPictureFragment
        }
        pictureFour {
          ...GravityPictureFragment
        }
      }
    }

    ... on GlobalSetAndromeda {
      banners {
        ... on GlobalWidgetSirius {
          picture {
            ...GravityPictureFragment
          }
        }
      }
    }

    ... on multiCategoryCardSet {
      banners {
        ... on categoryItemCard {
          picture {
            ...GravityPictureFragment
          }
        }
      }
    }

    ... on categoryItemCard {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalImageCard {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalCardScrollerCard {
      picture {
        ...GravityPictureFragment
      }
    }

    ... on GlobalCardScrollerSet {
      banners {
        ... on GlobalCardScrollerCard {
          picture {
            ...GravityPictureFragment
          }
        }
      }
    }

    ... on GlobalTabbedWidgetSet {
      banners {
        ... on GlobalFourItemEditorial {
          pictures {
            pictureOne {
              ...GravityPictureFragment
            }
            pictureTwo {
              ...GravityPictureFragment
            }
            pictureThree {
              ...GravityPictureFragment
            }
            pictureFour {
              ...GravityPictureFragment
            }
          }
        }
      }
    }

    ... on GlobalImageCardSet {
      banners {
        ... on GlobalImageCard {
          picture {
            ...GravityPictureFragment
          }
        }
      }
    }

    ... on EmailReEngagementModal {
      picture {
        ...GravityPictureFragment
      }
    }
  }
`
